let tempStripePk =
  'pk_test_51LfS67Jc8cbXO9ro6k4aGYR8PycfW8Cvxe4rbtv04RvKkCcCIIrDw73pwtfmugLf0QfNCWTmM1O8xSrraweDMK1m008vCIp89P';
if (window.location.hostname === 'web.getporter.io') {
  tempStripePk =
    'pk_live_51LfS67Jc8cbXO9roNuTrOeozNymkbNvAfGvTfxiAStlYr2cKW0KJeLd77yUlrum3keA8yzwCHD9b47xzW7llyz5300ADD5FR35';
}
const STRIPE_PK = tempStripePk;
export default STRIPE_PK;
